import React, { useEffect, useState } from "react";
import Button from "./Button";
import { removeImageReq } from "../../services/commonService/removeImageService";
import useMutation from "../../hooks/useMutation";
import { toast } from "react-toastify";

const FileUploadMultiple = ({
  label,
  labelClasses = "",
  required = false,
  accept = "image/*",
  errorType,
  errorText,
  onRemove = () => {},
  onChange = () => {},
  values,
  sectionId,
}) => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    if (values && Array.isArray(values) && values?.length > 0) {
      setImages(values);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(values)]);

  function handleFileChange(e) {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    const acceptList = accept.split(",").map((ext) => ext.trim());

    // Validate file type
    const validFiles = files.filter((file) => acceptList.includes(file.type) || accept.includes("image/*"));
    if (validFiles.length === 0) return;

    const newImages = validFiles.map((file) => ({
      file,
      url: URL.createObjectURL(file),
    }));

    setImages((prev) => [...prev, ...newImages]);
    onChange([...images, ...newImages]);

    e.target.value = "";
  }

  // const {
  //   mutate: removeImage,
  //   error,
  //   isPending: isLoading,
  // } = useMutation({
  //   mutationFn: async ({ sectionId, index }) => {
  //     const res = await removeImageReq({
  //       id: sectionId,
  //       imageId: index,
  //     });
  //     return { res, index };
  //   },
  //   onSuccess: (data) => {
  //     const { res, index } = data;
  //     if (res?.status === 200 || res?.status === 201) {
  //       if (res?.status === 200) {
  //         const updatedImages = images.filter((img, i) => img?._id !== index);
  //         setImages(updatedImages);
  //         onRemove(updatedImages);
  //       }
  //     } else {
  //       toast.warning(res?.message || res?.error);
  //     }
  //   },
  //   onError: (error) => {
  //     console.log(error);
  //   },
  // });

  return (
    <div className="w-full relative">
      {label && (
        <div className={`text-xs font-medium font-Poppins text-shades-07 mb-1 ${labelClasses}`}>
          {label}
          {required && (
            <span className="text-[8px] text-red-500 ml-1 absolute top-[-2px]">
              <i className="fa-solid fa-asterisk"></i>
            </span>
          )}
        </div>
      )}

      <div className="mt-2 flex flex-wrap gap-2">
        <label className="w-20 h-20 flex rounded-md border border-dashed items-center justify-center cursor-pointer">
          <i className="fa-fw fa-regular fa-plus text-shades-06 text-4xl"></i>
          <input multiple type="file" accept={accept} onChange={handleFileChange} className="hidden" />
        </label>

        {images.length > 0 &&
          images.map((img, index) => (
            <div key={index} className="relative w-20 h-20">
              <img src={img?.url} alt="Uploaded preview" className="w-full h-full object-cover rounded-md" />
              <Button
                type="button"
                buttonClasses="!absolute top-1 right-1 bg-chestnut-rose text-white !text-xs rounded-full !h-4 !w-4 !p-0"
                buttonIcon={"fa-light fa-xmark"}
                buttonIconPosition={"left"}
                // buttonFunction={() => {
                //   removeImage({ sectionId, index: img?._id });
                // }}
                buttonFunction={() => {
                  const updatedImages = images.filter((_, i) => i !== index);
                  setImages(updatedImages);
                  onRemove(updatedImages);
                }}
              />
            </div>
          ))}
      </div>

      {errorType && (
        <div
          className={`text-xs mt-1 ${
            errorType === "error"
              ? "text-red-600"
              : errorType === "warning"
              ? "text-amber-600"
              : errorType === "success"
              ? "text-green-600"
              : "text-sky-600"
          }`}>
          <i
            className={`fa-regular fa-fw ${
              errorType === "error"
                ? "fa-square-exclamation"
                : errorType === "warning"
                ? "fa-triangle-exclamation"
                : errorType === "success"
                ? "fa-circle-check"
                : "fa-circle-info"
            } text-sm mr-1`}></i>
          {errorText}
        </div>
      )}
    </div>
  );
};

export default FileUploadMultiple;
